import React from "react";
import { Button } from "@mui/material";
import DownladIcon from "./../../../assets/svg/download.svg";
import { SideMenu, BackHeader } from "./../../components";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
let AssignmentView = (props) => {
  const navigate = useNavigate();
  return (
    <SideMenu>
      <div className="page-container">
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={10} lg={10} md={10} sm={4} xs={4}>
              <BackHeader backHanler={() => navigate(-1)} />
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={8} xs={8}>
              <Button
                className="header-button"
                variant="text"
                onClick={() => navigate("/student-panel/assignment/create")}
              >
                <p className="page-header-button-text">Submit Task</p>
              </Button>
            </Grid>
          </Grid>
        </Box>
        <div className="view-assignment-data-main">
          <p className="view-assignment-title">Subject Name: </p>
          <p className="view-assignment-description">Maths</p>
        </div>
        <div className="view-assignment-data-main">
          <p className="view-assignment-title">Date:</p>
          <p className="view-assignment-description">03-03-2022</p>
        </div>
        <div className="view-assignment-data-main">
          <p className="view-assignment-title">Task name:</p>
          <p className="view-assignment-description">
            Nam ac velit eu magna placerat mattis sit amet et velit. Cras
            eleifend ante id aliquam sagittis.
          </p>
        </div>
        <div className="view-assignment-data-main">
          <p className="view-assignment-title">Remarks</p>
        </div>
        <p className="view-assignment-description">
          Nam ac velit eu magna placerat mattis sit amet et velit. Cras eleifend
          ante id aliquam sagittis. Curabitur vitae neque neque. Phasellus et
          feugiat ex. Aenean ultricies est ut dignissim varius. Ut quis lacus
          auctor, faucibus neque scelerisque, tempus nunc. Maecenas consectetur
          purus sit amet nisl pharetra varius. Ut malesuada scelerisque purus,
          quis luctus dolor consectetur vel. Mauris lacinia neque ac ullamcorper
          scelerisque. Vestibulum elementum iaculis ex id ultricies. Phasellus a
          justo dolor. Sed quis ex nec risus mattis volutpat.
        </p>
        <br />
        <br />
        <Button>
          <img src={DownladIcon} />
        </Button>
      </div>
    </SideMenu>
  );
};
export default AssignmentView;
